import { Fab, SvgIcon, Tooltip } from "@mui/material";
import {ReactComponent as  IconPrinter} from '../../../images/printer.svg';
import { useProduct } from "../../store/product";
import { useEffect, useRef } from "react";
import { useCheckoutData } from "../../hooks/use-checkout-data";
import icLib from "../../lib/icLib";
import l10n from "../../lib/l10n";

function PrintPreviewTool() {
  const product = useProduct(s => s.product);
  const $popupID = useRef();
  const $channel = useRef( new BroadcastChannel('cropper-preview') );
  const checkoutData = useCheckoutData();

  const onClick = () => {
    const url = l10n.url_viewprint + icLib.__e( JSON.stringify( checkoutData.get()._wppr_cropper ) );
    const name = product.name;
    const specs = ['width=480', 'height=640', 'popup=1'];
    $popupID.current = window.open( url, name, specs.join(',') );
  }

  useEffect(() => {
    $channel.current.onmessage = function(response) {
      if (response.data?.action
      && response.data.action === 'yo') {
        $popupID.current?.close();
        window.focus();
      }
    }
  }, []);

  return (
    <>
      <Tooltip title={l10n.ui_label_print_preview_text} placement="top">
        <Fab onClick={onClick}>
          <SvgIcon component={IconPrinter} viewBox="0 0 16 16"/>
        </Fab>
      </Tooltip>
    </>
  )
};

export default PrintPreviewTool;